export const server =
  process.env.REACT_APP_BACKEND_URL ||
  "https://ochrel-school-backend.onrender.com/api";
export const frontend =
  process.env.REACT_APP_WEBSITE_URL || "https://school.ochrelshop.com";
